/**
 * DocIcon — sanitized from `assets/newSvg/doc.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function DocIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M18,2 C19.1046,2 20,2.89543 20,4 L20,20 C20,21.1046 19.1046,22 18,22 L6,22 C4.89543,22 4,21.1046 4,20 L4,4 C4,2.89543 4.89543,2 6,2 L18,2 Z M12,13 L9,13 C8.44772,13 8,13.4477 8,14 C8,14.5523 8.44772,15 9,15 L12,15 C12.5523,15 13,14.5523 13,14 C13,13.4477 12.5523,13 12,13 Z M15,8 L9,8 C8.44772,8 8,8.44772 8,9 C8,9.51283143 8.38604429,9.93550653 8.88337975,9.9932722 L9,10 L15,10 C15.5523,10 16,9.55228 16,9 C16,8.48716857 15.613973,8.06449347 15.1166239,8.0067278 L15,8 Z"
        fill={color}
      />
    </Svg>
  );
}

export default DocIcon;
